import Vue from 'vue'
let EventBus = new Vue()
export default EventBus
